import { render, staticRenderFns } from "./TeamCalendarSvg.vue?vue&type=template&id=7479ddec&"
import script from "./TeamCalendarSvg.vue?vue&type=script&lang=ts&"
export * from "./TeamCalendarSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports